<div class="row">
  <div class="emulationOuter">
    <div class="emulationPage">
      <h3 class="margin-b10">
        Emulate User
      </h3>
      <div class="emulationTop">
        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="wide100">
              <mat-label>Logged In User #</mat-label>
              <input matInput type="text" name="loggedInUser" [(ngModel)]="loggedInUserText" [readonly]="true">
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field class="wide100">
              <mat-label>User to emulate</mat-label>
              <input matInput type="text" name="UserToEmulate" [(ngModel)]="userToEmulateText" [(readonly)]="isSetEmulation">
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field class="wide100">
              <mat-label>Emulating User Id</mat-label>
              <input matInput type="text" name="EmualtedUser" [(ngModel)]="emulatedUserIdText" disabled>
            </mat-form-field>
          </div>
        </div>
        <div class="row margin-t10">
          <div class="col-md-12 text-right">
            <button mat-raised-button class="btns margin-r10" color="primary" [(disabled)]="isSetEmulation" (click)="setEmulation()">Set Emulation</button>
            <button mat-raised-button class="btns" color="primary" [disabled]="!isSetEmulation" (disabledChange)="isSetEmulation = $event" (click)="clearEmulation()">Clear Emulation</button>
          </div>
        </div>
      </div>
      <div [ngClass]="{'disabledDiv':isSetEmulation == true}">
        <div class="search-box landingPageSearch">
          <span class="search-icon pt-1">
            <i class="fas fa-search"></i>
          </span>
          <div class="select-container material-select pt-1">
            <ng-select #select name="ddlDistrict"
                       [items]="districtList"
                       [(ngModel)]="selectedDistrict"
                       [virtualScroll]="true"
                       bindLabel="data"
                       bindValue="id"
                       (change)="districtSearchOnClose($event);"
                       class="custom-select-grower searchIcon lpSearch"
                       placeholder="Select Sales Team Member"
                       [closeOnSelect]="true"
                       [searchFn]="districtSearchFn"
                       (search)="districtFn($event)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h5 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.data}}
                      </h5>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
        <div class="row accountPageTopFilter margin-t20">
          <div class="col-md-12 col-lg-12">
            <app-efulfillmentfilter [disableSearchBtn]="isSetEmulation" [filters]="filterArray" [cleanFilter]="cleanAccount" (SearchFilter)="filterGrid($event)" [IsEmulationTab]='true'></app-efulfillmentfilter>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 margin-t10">
            <h4>
              Attached Accounts
            </h4>
          </div>
        </div>
        <div class="margin-t10">
          <div class="row">
            <div class="col-md-12">
              <div class="tableContainer">
                <table class="matTables mat-table">
                  <thead>
                    <tr>
                      <th class="mat-header-cell text-center"> Account No </th>
                      <th class="mat-header-cell text-center"> Account Name </th>
                      <th class="mat-header-cell text-center"> City </th>
                      <th class="mat-header-cell text-center"> State </th>
                    </tr>
                  </thead>
                  <tbody *ngIf="attachedAccountsList.length != 0 ; else noRecordAA">
                    <tr *ngFor="let item of attachedAccountsList">
                      <td class="mat-cell text-center" (click)="accountClick(item.account)">
                        <p class="attachAccountNo">{{item.account}}</p>
                      </td>
                      <td class="mat-cell text-center">
                        <p>{{item.accountName}}</p>
                      </td>
                      <td class="mat-cell text-center">
                        <p>{{item.city}}</p>
                      </td>
                      <td class="mat-cell text-center">
                        <p>{{item.state}}</p>
                      </td>
                    </tr>
                  </tbody>
                  <ng-template #noRecordAA>
                    <tbody>
                      <tr>
                        <td colspan="4" class="mat-cell noRecordMsg">
                          No Record Found.
                        </td>
                      </tr>
                    </tbody>
                  </ng-template>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 margin-t20">
            <h4>
              Attached Users
            </h4>
          </div>
        </div>
        <div class="margin-t10">
          <div class="row">
            <div class="col-md-12">
              <div class="tableContainer">
                <table class="matTables mat-table attachedUserTable">
                  <thead>
                    <tr>
                      <th class="mat-header-cell text-center"> User ID</th>
                      <th class="mat-header-cell text-center"> Name </th>
                      <th class="mat-header-cell text-center"> Role </th>
                    </tr>
                  </thead>
                  <tbody *ngIf="attachedUserList.length != 0 ; else noRecordAU">
                    <tr *ngFor="let userItem of attachedUserList">
                      <td class="mat-cell text-center attachAccountNo" (click)="userIdClick(userItem.id)">
                        {{userItem.id}}
                      </td>
                      <td class="mat-cell text-center">
                        {{userItem.value}}
                      </td>
                      <td class="mat-cell text-center">
                        {{userItem.data}}
                      </td>
                    </tr>
                  </tbody>
                  <ng-template #noRecordAU>
                    <tbody>
                      <tr>
                        <td colspan="3" class="mat-cell noRecordMsg">
                          No Record Found.
                        </td>
                      </tr>
                    </tbody>
                  </ng-template>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
